import { dateFormats } from '@GUTIL'
import { getTimezone } from '@GUTIL/other'
import { PrefixID } from '@GUTIL/hardCode'

import { app } from '@/main'

//moment格式轉為iso格式
export const IsoFormat = (valueOne, valueTwo) => {
  let hasTwoValue = !!valueOne && !!valueTwo
  if (hasTwoValue) {
    // console.log("fff", valueOne, valueTwo);
    let isDate = !valueOne._f || valueOne._f === dateFormats.date
    let isTime = !!valueTwo._f && valueTwo._f === dateFormats.time
    let date = ''
    let time = ''
    switch (`${isDate}_${isTime}`) {
      case 'true_true':
        date = valueOne.format(dateFormats.date)
        time = valueTwo.format(dateFormats.time)
        return moment(`${date} ${time}`).toISOString()
      case 'false_false':
        date = valueTwo.format(dateFormats.date)
        time = valueOne.format(dateFormats.time)
        return moment(`${date} ${time}`).toISOString()
      default:
        console.error('輸入格式錯誤，請重新確認')
    }
  } else {
    return valueOne.toISOString()
  }
}

//iso格式轉為純文字
/*
提供下述相關開關設定：
1. hasSec：切換是否顯示秒數，預設false，不顯示秒;true則顯示秒數
2. isLocal：切換是否顯示當地時區，預設true，false則顯示+8時區
*/
export const toDateString = (value, hasSec = false, isLocal = true) => {
  let info = ''
  let zone = getTimezone(false)
  !!value &&
    !isLocal &&
    (info = moment(value).format(
      `${dateFormats.date} ${
        hasSec ? dateFormats.time : dateFormats.time_no_sec
      }`
    ))
  !!value &&
    isLocal &&
    (info = moment(value)
      .utcOffset(zone)
      .format(
        `${dateFormats.date} ${
          hasSec ? dateFormats.time : dateFormats.time_no_sec
        }`
      ))
  return info
}

// 轉換 UNIX Timestamp 格式 (10位數)
export const toUnixTimestamp = data => {
  let dateTime = new Date(data).getTime()
  return Math.floor(dateTime / 1000)
}

// UNIX 轉成 Date String
export const unixTimestampToStr = (timestamp, hasSec) => {
  try {
    return toDateString(new Date(timestamp * 1000).toISOString(), hasSec)
  } catch (e) {
    console.error('輸入格式錯誤，請重新確認')
  }
}

export const isValidDate = inputDate => {
  return moment(new Date(inputDate)).isAfter(
    moment(new Date('1970-01-01T00:00:00Z'))
  )
}

export const isValidUnixTimestamp = timestamp => {
  return moment(new Date(timestamp * 1000)).isAfter(
    moment(new Date('1970-01-01T00:00:00Z'))
  )
}

//filter-加上千分位符號
export const commaFormat = value => {
  let info = '0'
  value &&
    (info = value
      .toString()
      .replace(
        /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
        (all, pre, groupOf3Digital) => {
          return pre + groupOf3Digital.replace(/\d{3}/g, ',$&')
        }
      ))
  return info
}

//email format check
export const validateEmail = email => {
  let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

/**
 * 左補零至指定長度
 * @param {string} str          來源數值
 * @param {number} length       指定長度
 */
export const paddingZeroLeft = (str, length) => {
  if (str.length >= length) return str
  else return paddingZeroLeft('0' + str, length)
}

/**
 * 右補零至指定長度
 * @param {string} str          來源數值
 * @param {number} length       指定長度
 */
export const paddingZeroRight = (str, length) => {
  if (str.length >= length) return str
  else return paddingZeroRight(str + '0', length)
}

/**
 * 數值補到指定小數位數
 * @param {string} str          來源數值
 * @param {number} length       指定小數位數
 * @param {Boolean} isFixed     是否只顯示到有數字的小數位數
 */
export const paddingDecimal = (str, length = 2, isFixed = false) => {
  let format = parseFloat(str).toFixed(length)
  // 只顯示到有數字的小數位數
  format = !isFixed ? parseFloat(format) : format
  // 避免顯示科學記號表示
  let scientificNotation = ''
  if (format.toString().indexOf('e') !== -1) {
    scientificNotation = format.toString().split('e')[1]
    format = format.toFixed(Number(scientificNotation[1]))
  }
  return format === 'NaN' ? str : format
}

/**
 * 數值補到指定小數位數 (無條件捨去)
 * @param {string} str        來源數值
 * @param {number} length     指定小數位數
 */
export const paddingFloorDecimal = (str, length = 2) => {
  let num = Math.floor(parseFloat(str) * 100) / 100
  let format = num.toFixed(length)
  return format === 'NaN' ? str : format
}

// 移除首英文字母
export const removeFirstLetter = val => {
  try {
    if (/^[a-zA-Z]/.test(val[0])) {
      return val.slice(1)
    }
    return val
  } catch (e) {
    return val
  }
}

// csv字串格式
export const csvFormat = val => {
  return `${val}\t`
}

// 過濾 id
export const compareId = (str, id, length = 6) => {
  if (!id) return ''
  if (
    str &&
    id &&
    new RegExp(`^($|${str}[0-9]{${length}}$)`).test(id) &&
    parseInt(id.slice(-length)) > 0
  ) {
    return parseInt(id.slice(-length))
  } else {
    return -1
  }
}

export const dateList = [
  {
    key: 0,
    type: 0,
    lang: 'i18n_that_day'
  },
  {
    key: 2,
    type: 2,
    lang: 'i18n_7day_before'
  },
  {
    key: 3,
    type: 3,
    lang: 'i18n_30day_before'
  }
]
/**
 * 時間防呆 - Add by Noey 2019.11.25
 * 參考: 訂單管理(時間搜尋部分)
 * reservedMonths: 開始日期不可超過兩個月份前的第一天 （ex: 假設今天為6/29號, startDate可以選擇到4/1)
 * startD: 開始日期 - 選取的日期不可超過選擇的區間(不能選的日期disable)
 * startDNoRange 開始日期不可超過結束日期
 * endD: 結束日期 - 選取的日期不可小於開始日期(不能選的日期disable)
 * startH: 開始時間(小時) - 如開始日期 = 結束日期, 選取的時間不可小於結束時間(不能選的時間disable)
 * endH: 結束時間(小時) - 選取的時間不可小於開始時間(不能選的時間disable)
 * startM: 開始時間(分鐘) - 如開始日期 = 結束日期, 選取的時間不可大於結束時間(不能選的時間disable)
 * endM: 結束時間(小時) - 選取的時間不可小於開始時間(不能選的時間disable)
 * changSD: 開始日期change functioin - 判斷如開始日期 > 結束日期 => 開始日期 = 結束日期
 * changED: 結束日期change functioin - 判斷如開始日期 > 結束日期 => 結束日期 = 開始日期
 */
export const disDate = {
  reservedMonths(current, d, months = 2) {
    // find first date before 2 months (default)
    const restrictedDate = moment()
      .subtract(months, 'months')
      .startOf('month')
    return (
      (current && (d.endDate < current || current >= moment().endOf('day'))) ||
      current < restrictedDate
    )
  },
  startD(current, d, r = 29) {
    return (
      (current && (d.endDate < current || current >= moment().endOf('day'))) ||
      current < moment(d.endDate).subtract(r, 'days') //選區間不可超過30天
    )
  },
  startDNoRange(current, d) {
    return (
      current &&
      (d.endDate.endOf('day') <= current || current >= moment().endOf('day'))
      // (d.endDate.endOf('day') < current.endOf('day') ||
      //   current.endOf('day') > moment().endOf('day'))
    )
  },
  endD(current, d) {
    return (
      current && (d.startDate > current || current >= moment().endOf('day'))
    )
  },
  startH(d) {
    if (d.startDate.format('YYYYMMDD') === d.endDate.format('YYYYMMDD')) {
      let a = Array.from(
        { length: 24 - d.endTime.hour() },
        (v, i) => i + d.endTime.hour() + 1
      )
      return a
    }
  },
  endH(d) {
    if (d.startDate.format('YYYYMMDD') === d.endDate.format('YYYYMMDD')) {
      let a = Array(d.startTime.hour())
        .fill()
        .map((value, index) => index)
      return a
    }
  },
  startM(h, d) {
    if (d.startDate.format('YYYYMMDD') === d.endDate.format('YYYYMMDD')) {
      if (h === d.endTime.hour()) {
        let a = Array.from(
          { length: 59 - d.endTime.minute() },
          (v, i) => i + d.endTime.minute() + 1
        )
        if (d.startTime > d.endTime) {
          d.startTime = d.endTime
        }
        return a
      }
    }
  },
  endM(h, d) {
    if (d.startDate.format('YYYYMMDD') === d.endDate.format('YYYYMMDD')) {
      if (h === d.startTime.hour()) {
        let a = Array(d.startTime.minute())
          .fill()
          .map((value, index) => index)
        if (d.startTime > d.endTime) {
          d.endTime = d.startTime
        }
        return a
      }
    }
  },
  changSD(val, mode, d) {
    if (mode === d.endDate.format('YYYY-MM-DD')) {
      if (d.startTime > d.endTime) {
        d.startTime = d.endTime
      }
    }
  },
  changED(val, mode, d) {
    if (mode === d.startDate.format('YYYY-MM-DD')) {
      if (d.startTime > d.endTime) {
        d.endTime = d.startTime
      }
    }
  }
}

/**
 * 時間區間按鈕 - Add by Noey 2019.11.25
 * 0: 當日、1: 前一天、2: 七天、3: 前30天
 * 用法: 將選取的時間區間日期帶入datepicker欄位內
 * 參考: 訂單管理(時間搜尋部分)
 */
export const setDateItem = (val, d) => {
  switch (val) {
    case 0:
      d.startDate = moment()
      d.startTime = moment('00:00:00', dateFormats.time)
      d.endDate = moment()
      d.endTime = moment('23:59:59', dateFormats.time)
      break
    case 1:
      d.startDate = moment().subtract(1, 'days')
      d.startTime = moment('00:00:00', dateFormats.time)
      d.endDate = moment().subtract(1, 'days')
      d.endTime = moment('23:59:59', dateFormats.time)
      break
    case 2:
      d.startDate = moment().subtract(6, 'days')
      d.startTime = moment('00:00:00', dateFormats.time)
      d.endDate = moment()
      d.endTime = moment('23:59:59', dateFormats.time)
      break
    case 3:
      d.startDate = moment().subtract(29, 'days')
      d.startTime = moment('00:00:00', dateFormats.time)
      d.endDate = moment()
      d.endTime = moment('23:59:59', dateFormats.time)
      break
  }
}

//pagination格式(c#)
export const psDefault = {
  offset: 0,
  limit: 30
}

//取當前在第幾頁 - current
export const getCurrentPage = (offset, limit = psDefault.limit) => {
  let current = 1
  offset &&
    (current =
      offset % limit == 0 ? offset / limit + 1 : Math.ceil(offset / limit))
  return current
}

//重組paging格式
/*
欄位說明:
offset：回傳的第一筆資料，在所有資料陣列的位置
limit：每頁資料筆數
pages：資料總頁數
count：資料總筆數
current：當前頁數
*/
export const resFormat = obj => {
  const paging = {
    offset: 'offset',
    limit: 'pageSize',
    pages: 'page_count',
    count: 'total'
  }
  let newObj = {}
  Object.keys(obj).forEach(key => {
    newObj[paging[key]] = obj[key]
  })
  newObj['current'] = getCurrentPage(obj.offset, newObj.pageSize)
  return newObj
}

export const toUpperCaseFirstChar = str =>
  str.charAt(0).toUpperCase() + str.slice(1) // first char toUpperCase

/**
 * 帳號編號
 * @param {String} val 流水編號
 */
export const accountFormat = val => {
  return val ? PrefixID.USER + paddingZeroLeft(val, 6) : ''
}
